import CachedIcon from "@mui/icons-material/Cached";
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import {
  Button,
  CircularProgress,
  Collapse,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { calificarResultado } from "../../../../controllers/operaciones";
import { ModalRating } from "../../../Modal/ModalRating";
import { useActividadesContext } from "../../Hook/useActividades";
import { useAuthContext } from "../../../../hooks/Auth";
import SpinnerUmmIA from "../../../Loading/SpinnerUmmIA";

type ActionsButtonsFooterProps = {
  isButtonDisabled: boolean;
};

export const ActionsButtonsFooter: React.FC<ActionsButtonsFooterProps> = ({
  isButtonDisabled,
}) => {
  const {
    cargando,
    handleGenerate,
    primerLlamadoAPI,
    objProyectoResultadoId,
    respuestaGenerada,   
    editMode,
    respuestaAPI,
    mostrarCampos
  } = useActividadesContext();  
  const [modalOpen, setModalOpen] = useState(false);
  const [rating, setRating] = useState<number>(3);
  

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRating = (n: number) => setRating(n);

  const handleGuardarCalificacion = async () => {
    const { resultadoId } = objProyectoResultadoId;
    console.log(
      `Calificando resultado: resultadoId={${resultadoId}}, rating={${rating}}`
    );
    if (rating && resultadoId) {
      await calificarResultado(resultadoId, rating);
    }
    handleCloseModal();
  };

  return (
    <>
      {/* Modal integrado */}
      <ModalRating
        handleCloseModal={handleCloseModal}
        handleRating={handleRating}
        modalOpen={modalOpen}
        handleGuardarCalificacion={handleGuardarCalificacion}
        rating={rating}
      />

      <Grid
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          flexDirection: "row",
          m: 2,
          width: "100%",
        }}
      >
     {/**    {respuestaGenerada && (
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              m: 2,
            }}
          >
            <Button
              variant="contained"
              onClick={handleOpenModal}
              sx={{
                borderRadius: 5,
                borderColor:"#FFFFFF",
                backgroundColor:" #FFF",
                width: "100%",
                alignContent: "center",
                color: "#6A93A8",
                fontFamily: "montserrat",
                fontSize: 15,
                fontWeight: "bold",
                "&:hover": {
                  borderColor:"#FFFFFF",
                  color: "#336B87",
                  backgroundColor:" #FFF",
                },
                "&:focus": {
                  backgroundColor:" rgba(249, 186, 50, 0.5)",
                  color: "#336B87",
                  boxShadow: "none",
                },
              }}
              disabled={cargando}
            >
              Calificar respuesta
              <StarHalfRoundedIcon fontSize="small" />
            </Button>
          </Grid>
        )}     */}  
  <Collapse in={mostrarCampos} unmountOnExit timeout={300}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            m: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleGenerate}
            sx={{
              borderRadius: 5,
              fontSize: 15,
              width: "100%",
              alignContent: "center",
              backgroundColor: "#1FC16B",
              "&:hover": {
                backgroundColor: "#34C759",
              },
              fontFamily: "montserrat",
              fontWeight: "bold",
            }}
          disabled={cargando || isButtonDisabled } 
          >
            {cargando ? (
              <SpinnerUmmIA logoWidth={25} logoHeight = {25}/>
            ) : primerLlamadoAPI ? (
              "Generar"
            ) : (
              <>
                Volver a Generar
                <CachedIcon />
              </>
            )}
          </Button>
        </Grid>
         </Collapse>
        
      </Grid>

      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            color: "#d10d10d10",
            fontWeight: "light",
            fontStyle: "italic",
            pb: "30px",
            pt: "30px",
          }}
        >
          Al utilizar ummIa usted acepta los{" "}
          <Link
            href="https://ummia.ai/wp-content/uploads/2025/09/Terminos-y-condiciones-UmmIA.docx.pdf"
            target="_blank"
            sx={{
              color: "#336B87",
              textDecoration: "underline",
              fontWeight: "light",
            }}
          >
            términos y condiciones
          </Link>{" "}
          de esta plataforma.
        </Typography>
      </Grid>
    </>
  );
};
